var _path, _g, _path2, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLungs(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2071_20537",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 3,
    y: 3,
    width: 11,
    height: 19
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.19 3H3V21.54H13.19V3Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2071_20537)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.2607 6.59983C9.1607 5.46983 7.8007 6.18983 6.5007 7.76983C4.8007 9.82983 4.4407 11.6298 4.0907 13.5298C3.6807 15.7498 3.2807 19.6798 5.2207 20.3698C6.2207 20.7298 13.0107 23.0698 10.8207 11.6598C10.6107 10.5698 11.3207 7.69983 10.2607 6.60983V6.59983Z",
    stroke: "#03122E",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.04102 11.5L12.441 9.15V3.75",
    stroke: "#03122E",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_2071_20537",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 11,
    y: 3,
    width: 11,
    height: 19
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.0005 3H11.8105V21.54H22.0005V3Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_2071_20537)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.7405 6.59983C15.8405 5.46983 17.2005 6.18983 18.5005 7.76983C20.2005 9.82983 20.5605 11.6298 20.9105 13.5298C21.3205 15.7498 21.7205 19.6798 19.7805 20.3698C18.7805 20.7298 11.9905 23.0698 14.1805 11.6598C14.3905 10.5698 13.6805 7.69983 14.7405 6.60983V6.59983Z",
    stroke: "#03122E",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.9605 11.5L12.5605 9.15V3.75",
    stroke: "#03122E",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLungs);
export default __webpack_public_path__ + "static/media/Lungs.6e93dbbf05f76fcb758d2332d4779f8b.svg";
export { ForwardRef as ReactComponent };